import React, { useEffect, useState } from "react";
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import 'dayjs/locale/en-gb';
import dayjs from "dayjs";

const DatePickerComponent = (props: any) => {
    //const [stringValue, setStringValue] = useState<string>('');
    const [dateValue, setDateValue] = useState<any>(null);


    useEffect(() => {
        if (props.model == null || props.field == null || props.model[props.field] == null){
            return;
        }

        const dateString = props.model[props.field];
        const parsedDate = dayjs(dateString, "YYYY-MM-DD");

        setDateValue(parsedDate);
        //let formattedValue = props.model[props.field]?.toISOString()?.substring(0,10);
        //setStringValue(formattedValue);
    }, [props.model]);

    function isValidDate(date:any) {
        var d = new Date(date);
        return !isNaN(d?.getTime());
    }

    function setModelEvent(value: any) {
        if (value == null || !isValidDate(value)) {
            value = null;
        }

        setDateValue(value);
        
        if (props.model != null && props.field != null) {
            const parsedDate = dayjs(value).format("YYYY-MM-DD");
            props.model[props.field] = parsedDate;
        }

        // if (props.model == null || props.fieldFormatted == null) { 
        //     return;
        // }

        // if (value == null) {
        //     props.model[props.fieldFormatted] = value;
        //     //setStringValue(value);
        //     return;
        // }

        // let formattedValue = value?.toISOString()?.substring(0,10);
        // //setStringValue(formattedValue);
        // props.model[props.fieldFormatted] = formattedValue;
    }

    return (
        <div className={props.divClassName}>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
                <DatePicker
                    className={props.className}
                    //required={props.required}
                    label={props.label}
                    disabled={props.disabled ?? false}
                    onChange={(e: any) => setModelEvent(e)} 
                    //placeholder={props.label}
                    value={dateValue}
                    format="DD/MM/YYYY" 
                    // style={{ marginRight: 10 }}
                />
            </LocalizationProvider>
        </div>
    )
}

export default DatePickerComponent